
























import { Component, Prop, Vue } from 'vue-property-decorator'

import { Location } from 'vue-router'

@Component
export default class MobileNavigationBar extends Vue {
  @Prop({ type: Array, required: true })
  readonly buttons!: { icon: string; text: string; route: Location }[]
}
